import { combineReducers } from "redux";

import { categoryReducer } from "./category";
import { goodsReducer } from "./goods";
import { cartReducer } from "./cart";
import { paymentReducer } from "./payment";

export const productPaymentReducer = combineReducers({
  cart: cartReducer,
  category: categoryReducer,
  goods: goodsReducer,
  payment: paymentReducer,
});
